import React, { Component } from 'react';
import RatePrice from './rate-price';
import placeholder from '../../images/PlaceholderRoss.png';

class HotelCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllRates: false
        };
    }

    onMoreRatesClick() {
        this.setState((prevState) => {
            return { showAllRates: !prevState.showAllRates };
        });
    }

    onModalActionClick() {
        this.props.openHotelViewPopUp(this.props.model.hotel);
    }

    render() {
        const { hotel: { name, code, starRating, city, address, pictures }, rates } = this.props.model;
        const { showAllRates } = this.state;
        const stars = Number(starRating.name.split(' ')[0]);
        let starsRating = [];

        const ratesCollection = rates.map((el, i) => <RatePrice rateObject={el} key={'ratePrice-'+i}/>);

        for (let i = 0; i < stars; i++) {
            starsRating.push(<span className="star-filled" />);
        }

        return (
            <div className="wrapper">
                <div className="hc-hotel-thumbnail">
                    <img
                        src={
                            pictures.length > 0 ? (
                                `http://www.travco.co.uk/images/hotels${pictures[0].link}`
                            ) : (
                                placeholder
                            )
                        }
                        alt={pictures.length > 0 ? pictures[0].name : 'No picture available'}
                    />
                </div>
                <div className="hc-info">
                    <div className="hc-hotel-name">
                        <div onClick={this.onModalActionClick.bind(this)}>
                            {name} ({code})
                        </div>
                    </div>
                    <div className="hc-quick-info">
                        <div className="hc-stars-rating" title={starRating.name}>
                            {starsRating}
                        </div>
                        <div className="hc-location">
                            <span className="pin" />
                            {address.streetLine}, {city.name}
                        </div>
                    </div>
                </div>
                {showAllRates ? ratesCollection : ratesCollection[0]}
                {ratesCollection.length > 1 && (
                    <div
                        className={showAllRates ? 'expand-wrapper  open' : 'expand-wrapper'}
                        onClick={this.onMoreRatesClick.bind(this)}>
                        <span className="down-chevron" />
                        {showAllRates ? 'Fewer Rates' : 'More Rates'}
                    </div>
                )}
            </div>
        );
    }
}

export default HotelCard;
